/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const changePasswordPostRequestSchema = z.object({
  previous_password: z.string(),
  proposed_password: z.string(),
});
